import qs from 'qs';
import { network } from 'services/network';

export const saveFilterBulkRemoveTags = (params) => {
    const querystring = qs.stringify(params.querystring, { addQueryPrefix: true, skipNulls: true });
    return network.post(`api/bo/saveFilterBulkRemoveTags${querystring}`, params.body).then((response) => {
        return response.data;
    });
};
